module.exports = __webpack_public_path__ + "ed8440bba7caae11cc1a4ea68aa8d777.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/icons/accordion-arrow.png
// module id = EICt
// module chunks = 0